<template>
  <BaseCard>
    <h2 font-weight="bold" class="p-2 text-lg font-bold text-primary-main">
      {{ title }}
    </h2>
    <slot />
  </BaseCard>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
});
</script>
